import {Component, OnInit} from '@angular/core';
import {UserService} from 'src/app/services/user/user.service';
import {NavigationService} from 'src/app/services/nav/navigation.service';
import {ActivatedRoute} from '@angular/router';
import {AppConfigHolder} from '../../services/app-config-holder';
import {AuthTokens, UtishaAuthApiService} from '@api/utisha-auth';
import {firstValueFrom} from 'rxjs';

@Component({
    selector: 'app-handle-federated-login',
    template: '',
    styles: [],
})
export class HandleFederatedLoginComponent implements OnInit {

  constructor(private nav: NavigationService,
              private route: ActivatedRoute,
              private userService: UserService,
              private appConfig: AppConfigHolder,
              private authApi: UtishaAuthApiService) { }

  async ngOnInit(): Promise<any> {
    const tokens = await this.getTokens();
    await this.userService.storeTokens(tokens);
    this.nav.home()
  }

  private async getTokens(): Promise<AuthTokens> {
    const sessionId = this.route.snapshot.queryParams.session_id;
    const provider = this.route.snapshot.queryParams.provider;
    const customer = this.appConfig.config.uid;
    return await firstValueFrom(this.authApi.retrieveTokens(sessionId, customer, provider));
  }

}
